import React from "react";
import { Facebook, Instagram, Linkedin, Twitter, Music2 } from "lucide-react";

// Social platforms supported on profiles (edit forms iterate SOCIAL_PLATFORMS)
export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook", Icon: Facebook, placeholder: "https://facebook.com/yourpage" },
  { key: "instagram", label: "Instagram", Icon: Instagram, placeholder: "https://instagram.com/you" },
  { key: "linkedin", label: "LinkedIn", Icon: Linkedin, placeholder: "https://linkedin.com/in/you" },
  { key: "tiktok", label: "TikTok", Icon: Music2, placeholder: "https://tiktok.com/@you" },
  { key: "x", label: "X (Twitter)", Icon: Twitter, placeholder: "https://x.com/you" },
];

export default function SocialLinks({ links = {}, testId = "social" }) {
  const entries = SOCIAL_PLATFORMS.filter((s) => links[s.key]);
  if (!entries.length) return null;
  return (
    <div className="flex gap-2 flex-wrap" data-testid={`${testId}-links`}>
      {entries.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={links[key]}
          target="_blank"
          rel="noreferrer"
          title={label}
          data-testid={`${testId}-${key}`}
          className="w-8 h-8 rounded-full bg-[#FCE6E9] border border-[#F8C8DC] flex items-center justify-center text-[#B2607F] hover:bg-[#F8C8DC] hover:text-[#374151] transition-colors"
        >
          <Icon className="w-3.5 h-3.5" />
        </a>
      ))}
    </div>
  );
}
